function PowerBILogs() {
  return (
    <div style={{ width: "90%", height: "90%" }}>
      <iframe
        title="Logs"
        style={{ width: "100%", height: "100%" }}
        src="https://app.powerbi.com/reportEmbed?reportId=6e9c21c7-299e-4bf4-8195-51ea85d47b3f&autoAuth=true&ctid=5fb461ed-7397-4bdd-9dc6-5db63180bbb1"
        frameborder="0"
        allowFullScreen="true"
      ></iframe>
    </div>
  );
}

export default PowerBILogs;
